import React, { useEffect, useState } from 'react'
import moment from 'moment'

type LiveClockProps = Omit<React.ComponentPropsWithoutRef<'span'>, 'children'> & {
  format?: string
  intervalMs?: number
}

export const LiveClock = ({ format = 'MMM D, HH:mm:ss', intervalMs = 1000, ...rest }: LiveClockProps) => {
  const [value, setValue] = useState(() => moment().format(format))

  useEffect(() => {
    setValue(moment().format(format))

    const timer = window.setInterval(() => {
      setValue(moment().format(format))
    }, intervalMs)

    return () => window.clearInterval(timer)
  }, [format, intervalMs])

  return <span {...rest}>{value}</span>
}
